import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Om vi är på startsidan utan aktiv navigation till en hash, scrolla till toppen
    if (pathname === '/' && !window.location.hash) {
      window.scrollTo(0, 0);
    } else if (pathname !== '/') {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}
